import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonSize, ButtonVariant } from '@app/modules/editor/shared/as-components/button/button.component';
import { HTMLElementModel } from '../../models/content.model';

@Component({
  selector: 'inline-image-editor-alt',
  templateUrl: './inline-image-editor-alt.component.html',
  styleUrl: './inline-image-editor-alt.component.scss',
  standalone: false,
})
export class InlineImageEditorAltComponent implements OnInit {
  btnSize = ButtonSize;

  btnVariant = ButtonVariant;

  form!: FormGroup;

  htmlString: string;

  overlayTheme = '';

  alt: string;

  inputForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InlineImageEditorAltComponent>,
    @Inject(MAT_DIALOG_DATA) public html: HTMLElementModel,
  ) {
    this.alt = html.data;
  }

  ngOnInit(): void {
    let preset = this.alt;
    if (!this.alt) {
      preset = '';
    }
    this.form = this.fb.group({
      value: [preset, [Validators.required]],
    });
  }

  confirm(): void {
    if (this.form.invalid) {
      return;
    }
    const alt = this.form.value.value;
    this.dialogRef.close(alt);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
